import React, { Component } from 'react'
import classnames from 'classnames'
import Select from 'react-select'
import { CSVLink } from 'react-csv'

import styles from './styles.css'

class ExportOptionsModal extends Component {
  state = {
    startDate: null,
    endDate: null,
  }

  render() {
    const {
      selectValue,
      selectOnChange,
      selectOptions,
      selectCustomStyles,
      placeholder,
      button1Name,
      button2Name,
      button1Function,
      button2Function,
      dateRangeOptions,
      handleOptionClick,
      selectedDateRange,
      csvData,
      csvFilename,
    } = this.props

    return (
      <div className={classnames(styles.form)}>
        <div className={classnames(styles.title)}>Export Log</div>
        <div className={classnames(styles.optionsContainer)}>
          <div className={classnames(styles.optionSection)}>
            <div className={classnames(styles.heading)}>Date range</div>
            <div className={classnames(styles.optionBlock)}>
              {dateRangeOptions.map(option => (
                <div className={classnames(styles.optionLine)}>
                  <button
                    className={classnames(styles.checkbox)}
                    onClick={() => handleOptionClick(option)}
                  >
                    <i
                      className={
                        selectedDateRange === option.value
                          ? 'hmm-icon-square-check'
                          : 'hmm-icon-square-empty'
                      }
                    />
                  </button>
                  <div className={classnames(styles.label)}>{option.label}</div>
                  <div className={classnames(styles.label)}>{`${option.startDate.format(
                    'MMM D'
                  )} - ${option.endDate.format('MMM D')}`}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={classnames(styles.optionSection)}>
            <div className={classnames(styles.heading)}>Type of Report</div>
            <Select
              className={classnames(styles.dropdown)}
              value={selectValue}
              onChange={selectOnChange}
              options={selectOptions}
              styles={selectCustomStyles}
              placeholder={placeholder}
            />
            {selectValue && (
              <div className={classnames(styles.columnLabel)}>{selectValue.columns}</div>
            )}
          </div>
        </div>
        <div className={classnames(styles.buttonContainer)}>
          <button className={classnames(styles.button)} onClick={button1Function}>
            {button1Name}
          </button>
          <button className={classnames(styles.button)} onClick={button2Function}>
            {button2Name}
          </button>
          {/* <CSVLink
            data={csvData}
            asyncOnClick={true}
            filename={csvFilename}
            className={classnames(styles.button)}
            onClick={button2Function}
            target="_blank"
          >
            {button2Name}
          </CSVLink> */}
        </div>
      </div>
    )
  }
}

export default ExportOptionsModal



// WEBPACK FOOTER //
// ./src/views/log/list/export-options-modal/index.js